import * as Font from 'expo-font';

export const useFonts = async () =>
	await Font.loadAsync({
		maisonNeue: require('../assets/fonts/MaisonNeueBook.ttf'),
	});
